import { IAdiantamentoEvento } from "interfaces/adiantamento";
import { FormFieldConfig } from "interfaces/forms";

type Fields = keyof IAdiantamentoEvento;

const formFieldAdiantamento: FormFieldConfig<Fields> = {
  id: {
    name: "id",
    label: "ID",
    type: "number",
  },
  urlComprovante: {
    name: "urlComprovante",
    label: "Url Comprovante",
    type: "text",
    errorMsg: "Campo url comprovante obrigatório.",
  },
  identificacaoTransacao: {
    name: "identificacaoTransacao",
    label: "Identificação Transação",
    type: "text",
    errorMsg: "Campo identificação transação obrigatório.",
  },
  solicitante: {
    name: "solicitante",
    label: "Solicitante",
    type: "text",
    errorMsg: "Campo solicitante obrigatório.",
  },
  dataSolicitacao: {
    name: "dataSolicitacao",
    label: "Data Solicitação",
    type: "date",
    errorMsg: "Campo data solicitação obrigatório.",
  },
  valorTransacao: {
    name: "valorTransacao",
    label: "Valor Transação",
    type: "number",
    errorMsg: "Campo valor transação obrigatório.",
  },
  dataPagamento: {
    name: "dataPagamento",
    label: "Data Pagamento",
    type: "date",
  },
  status: {
    name: "status",
    label: "Status",
    type: "text",
    errorMsg: "Campo status obrigatório.",
  },
  obs: {
    name: "obs",
    label: "Observação",
    type: "text",
  },
  nomeResponsavel: {
    name: "nomeResponsavel",
    label: "Responsavel",
    type: "text",
    errorMsg: "Campo nome do responsável obrigatório.",
  },
  celPhone: {
    name: "celPhone",
    label: "Celular",
    type: "text",
  },
  eventoId: {
    name: "eventoId",
    label: "ID Evento",
    type: "number",
    errorMsg: "Campo evento obrigatório.",
  },
  contaFinanceiraId: {
    name: "contaFinanceiraId",
    label: "Conta financeira",
    type: "text",
    errorMsg: "Selecione a conta financeira para recebimentos pagos.",
  },
};

export default formFieldAdiantamento;
